module.exports = __webpack_public_path__ + "static/pernod_ricard_logo.3c581e66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience/pernod_ricard_logo.jpg
// module id = 484
// module chunks = 35783957827783